export const LOGIN_ROUTE='/login';
export const CATEGORIES_ROUTE='/categories';
export const HOMEPAGE_ROUTE='/';
export const REGISTER_ROUTE='/register';
export const REVIEW_ROUTE='/review';
export const MYPAGE_ROUTE='/my-page';
export const ADDREVIEWPAGE_ROUTE='/add-review';
export const ADMIN_ROUTE='/admin';
